import { authAdapter } from "@/core/auth/adapter";
import { PortalLayout } from "@/layouts/portal/PortalLayout";
import { PORTAL_PATH } from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor")({
	beforeLoad: ({ location }) => {
		if (location.pathname === PORTAL_PATH.Login) return;

		const state = authAdapter.getState();
		const vendorID = state.user?.vendorID;

		// No vendor: fail closed.
		if (state.status !== "authenticated" || !vendorID) {
			if (state.status === "authenticated") {
				void authAdapter.logout();
			}

			throw redirect({
				to: PORTAL_PATH.Login,
				search: { redirect: location?.href ?? PORTAL_PATH.Home },
			});
		}
	},
	component: PortalLayout,
});
